import type { ExternalTableSchema } from '@packages/table-builder';

export const invalidPasswordResetAnalyticsTable: ExternalTableSchema = {
  metadata: {
    title: 'Invalid Password Reset Email Analytics',
    entity: 'InvalidPasswordResetEmailAnalytics',
  },

  dataSource: {
    endpoint: '/api/identity/api/invalid-password-reset-email-analytics',
    method: 'GET',
    rowIdField: 'id',
    responseMapping: {
      items: 'items',
      totalCount: 'totalCount',
    },
    requestParams: {
      MaxResultCount: 'table.pageSize',
      SkipCount: 'table.pageOffset',
      Sorting: 'table.sorting',
    },
    filters: [
      {
        name: 'DateFrom',
        placeholder: 'From Date',
        type: 'date',
      },
      {
        name: 'DateTo',
        placeholder: 'To Date',
        type: 'date',
      },
      {
        name: 'Email',
        placeholder: 'Username',
        type: 'text',
      },
      {
        name: 'CompanyName',
        placeholder: 'Company Name',
        type: 'text',
      },
    ],
  },

  columns: [
    {
      field: 'requestedEmail',
      header: 'Username',
      sortable: true,
      width: 250,
    },
    {
      field: 'attemptedAt',
      header: 'Attempted At',
      type: 'dateTimeLTS',
      sortable: true,
      width: 200,
    },
    {
      field: 'appPlatform',
      header: 'Platform',
      sortable: true,
      width: 150,
    },
    {
      field: 'companyName',
      header: 'Company Name',
      sortable: true,
      width: 200,
    },
  ],

  features: {
    search: { enabled: true },
    pagination: { defaultSize: 10, mode: 'pagination' },
  },
};
